export enum ProfileStatus {
  Active = 'Active',
  Disabled = 'Disabled',
  Initial = 'Initial',
}

export default ProfileStatus;
